import React from "react";
import Luniwave_logo from "../img/icone_beige 1.png";
import { useAuth } from "react-oidc-context";
import { useLanguage } from "../context/LanguageContext";

const Main = () => {
  const keycloak = useAuth();
  const { t, language, toggleLanguage } = useLanguage();

  const redirectToLogin = () => {
    // Configuration simple de la redirection vers /redirect
    const redirectConfig = {
      redirect_uri: window.location.origin + "/redirect",
    };

    keycloak.signinRedirect(redirectConfig);
  };

  return (
    <div className="Home_Page">
      <button className="language-switcher" onClick={toggleLanguage}>
        {language.toUpperCase()}
      </button>
      <div className="homepage_infos">
        <h1 className="homepage_title">{t.portalTitle}</h1>
        <span className="homepage_description">
          {t.descriptionPart1} <br /> {t.descriptionPart2}
        </span>
        <img src={Luniwave_logo} alt="Luniwave Logo" className="homepage_logo" />
      </div>
      <div className="homepage_connexion">
        <h2 className="homepage_connexion-title">{t.connexion}</h2>
        <p className="homepage_connexion-infos">
          {t.notClientYet}{" "}
          <a href="https://www.luniwave.com/contact" target="_blank" rel="noopener noreferrer">
            {t.contactUs}
          </a>
        </p>
        <button className="homepage_connexion-btn" onClick={redirectToLogin}>
          {t.signIn}
        </button>

        {/* <p className="homepage_connexion-pc">Politique de confidentialité</p> */}
      </div>
    </div>
  );
};

export default Main;
